import { chapters } from '../content';
export function searchChapters(query: string) {
  const words=query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if(!words.length) return chapters.slice(0,12);
  return chapters.map(chapter=>{
    const title=chapter.title.toLowerCase(), subtitle=chapter.subtitle.toLowerCase();
    const headings=chapter.sections.map(s=>s.title).join(' ').toLowerCase();
    const goals=chapter.goals.join(' ').toLowerCase();
    const full=[title,subtitle,headings,goals,chapter.sections.map(s=>s.body).join(' '),chapter.id.replaceAll('-',' ')].join(' ').toLowerCase();
    if(!words.every(word=>full.includes(word))) return {chapter,score:0};
    const score=1+(title.includes(words.join(' '))?100:0)+words.reduce((sum,word)=>sum+(title.includes(word)?20:0)+(subtitle.includes(word)?8:0)+(headings.includes(word)?4:0)+(goals.includes(word)?3:0),0);
    return {chapter,score};
  }).filter(x=>x.score>0).sort((a,b)=>b.score-a.score||a.chapter.number-b.chapter.number).slice(0,12).map(x=>x.chapter);
}
